import { getHttpExtras } from '@helpers/utils';
import * as Sentry from '@sentry/react';
import ky from 'ky';

export const createHttpClient = (baseUrl: string, token?: string) =>
  ky.create({
    prefixUrl: baseUrl,
    hooks: {
      beforeRequest: [
        async (request): Promise<void> => {
          if (!!token) request.headers.set('Authorization', `Bearer ${token}`);
        },
      ],
      beforeError: [
        async (error) => {
          Sentry.captureException(error, { level: 'error', extra: await getHttpExtras(error) });
          return error;
        },
        async (error) => {
          if (error.response) {
            const errorData = await error.response.json();
            throw errorData;
          }
          throw new Error(`Network error: ${error.message}`);
        },
      ],
    },
  });
